export default {
  colors: {
    primary: '#1e805f',
    primaryLight: '#f4f9f7;',
  },
}
